<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import PipelinePaywall from './PipelinePaywall.vue';

const props = defineProps({
  feature: { type: String, required: true },
});

const store = useStore();

// Dispara o fetch se ainda não foi feito (cobre acesso por URL direta)
onMounted(() => {
  if (
    !store.getters['subscription/hasFetched'] &&
    !store.getters['subscription/isFetching']
  ) {
    store.dispatch('subscription/fetchSubscription');
  }
});

const hasFetched = computed(() => store.getters['subscription/hasFetched']);

const hasAccess = computed(() => {
  if (!hasFetched.value) return null; // ainda carregando
  const features = store.getters['subscription/planFeatures'];
  if (features === null) return true; // sem assinatura = acesso total
  return features.includes('*') || features.includes(props.feature);
});
</script>

<template>
  <!-- Aguardando resposta da API de subscription -->
  <div v-if="hasAccess === null" class="w-full h-full" />

  <!-- Feature bloqueada no plano -->
  <PipelinePaywall v-else-if="!hasAccess" :feature="feature" />

  <!-- Feature liberada -->
  <slot v-else />
</template>
